module.exports = __webpack_public_path__ + "fonts/Graphik-Regular.af94fe62.ttf";